import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { Card, CardContent } from '../../components/ui/Card';
import { Link } from 'react-router-dom';

export const ForLeaders = () => {
  return (
    <div className="py-24 space-y-32">
      <section className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-[10px] font-black uppercase tracking-widest border border-indigo-100">
              For Ledere
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-slate-900 leading-none tracking-tighter uppercase">
              Verktøy for å <br/> <span className="text-indigo-600">trygge ditt lederskap</span>
            </h1>
            <p className="text-xl text-slate-500 leading-relaxed font-medium">
              Operativ ledelse er krevende. Vår plattform gir deg innsikten og de konkrete tiltakene du trenger for å lede teamet ditt gjennom både vekst og krevende perioder.
            </p>
            <div className="flex gap-4">
              <Link to="/booking"><Button variant="primary" size="lg">Se Ledermodul</Button></Link>
            </div>
          </div>
          <div className="bg-slate-100 rounded-[64px] overflow-hidden shadow-2xl relative">
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=1000" className="w-full h-full object-cover" alt="Leader support" />
          </div>
        </div>
      </section>

      <section className="bg-slate-50 py-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              { title: 'Personlig Dashboard', icon: 'Layout', desc: 'Få full oversikt over dine egne skårer og teamets utvikling over tid.' },
              { title: 'Tiltak per leder', icon: 'Target', desc: 'AI-genererte handlingsplaner som forteller deg nøyaktig hva du bør gjøre i dag.' },
              { title: 'Avdelingsanalyse', icon: 'BarChart', desc: 'Dypdykk i mønstre og rotårsaker som påvirker ditt arbeidsmiljø.' }
            ].map((f, i) => (
              <div key={i} className="space-y-6">
                <div className="w-14 h-14 rounded-2xl bg-indigo-600 flex items-center justify-center text-white shadow-xl shadow-indigo-200">
                  <SafeIcon name={f.icon} size={28} />
                </div>
                <h3 className="text-2xl font-black text-slate-900 uppercase tracking-tight">{f.title}</h3>
                <p className="text-slate-500 leading-relaxed font-medium">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6">
        <div className="bg-slate-900 rounded-[64px] p-20 text-white relative overflow-hidden text-center">
          <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500/10 rounded-full blur-[100px] -mr-48 -mt-48"></div>
          <h2 className="text-4xl font-black uppercase tracking-tighter mb-8">Oppfølging som faktisk fungerer</h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto mb-12 font-medium">
            Slutt å gjette på hvordan teamet har det. Bruk sanntidsdata til å ta beslutninger som reduserer stress og øker prestasjonene.
          </p>
          <Link to="/booking">
            <Button size="lg" className="bg-white text-indigo-600 border-none px-12 py-8 text-xl font-black uppercase tracking-widest">
              Book en samtale om lederstøtte
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};